module.exports = __webpack_public_path__ + "static/media/phone-edit.efdf2eba.png";